module.exports = __webpack_public_path__ + "static/img/clear.c6e367f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/neutral/clear.png
// module id = 44Oo
// module chunks = 0